import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { TemplateDialogButtonBase } from '../../shared/base/template-dialog-button-base';
import { CourseService } from "../../courses/shared/course.service";
import { Course } from "../../courses/shared/course";
import { storage } from 'firebase';
import {MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS, MESSAGE_CREATE_SUCCESS} from "../shared/message";
import { Syllabus } from "../shared/syllabus";
import {SyllabusImageService} from "../shared/syllabus-image.service";
import {SyllabusImage} from "../shared/syllabus-image";

@Component({
  selector: 'app-syllabus-photo-choice-button',
  templateUrl: './syllabus-photo-choice-button.component.html',
  styleUrls: ['./syllabus-photo-choice-button.component.scss']
})
export class SyllabusPhotoChoiceButtonComponent extends TemplateDialogButtonBase implements OnInit{

  @Input() index: number;
  @Input() course: Course;
  isDragOver: boolean;
  isUploaded = true;
  images: SyllabusImage[];

  constructor(
    dialog: MatDialog,
    snackBar: MatSnackBar,
    private courseService: CourseService,
    private syllabusImageService: SyllabusImageService
  ) {
    super(dialog, snackBar);
  }

  ngOnInit() {
    this.syllabusImageService.list.subscribe(images => {
      this.images = images;
    })
  }

  onFileOver(isOver: boolean) {
    this.isDragOver = isOver;
  }

  async onFileDrop(file: File) {
    try {
      this.isUploaded = this.isDragOver;
      const snapshot = await storage().ref(`/syllabus-card-photos/${file.name}`).put(file);
      const image = {
        'name': snapshot.metadata.name,
        'downloadURL': snapshot.downloadURL
      };
      this.syllabusImageService.push(image);
      this.handleSuccess();
    }catch (e) {
      this.handleError(e);
    }
  }

  async onSubmit(value: string) {
    try {
        switch(this.index) {
          case 1: {
            this.course.syllabus.advantage1Img = value;
            this.courseService.update(this.course.$key, this.course);
            break;
          }
          case 2: {
            this.course.syllabus.advantage2Img = value;
            this.courseService.update(this.course.$key, this.course);
            break;
          }
          case 3: {
            this.course.syllabus.advantage3Img = value;
            this.courseService.update(this.course.$key, this.course);
            break;
          }
          default: {
            break;
          }
        }
        this.dialog.closeAll();
    } catch (e) {
      this.handleError(e);
    }
  }

  private handleSuccess() {
    super.openSnackBar(MESSAGE_CREATE_SUCCESS);
  }

  private handleError(error: any) {
    super.openSnackBar(MESSAGE_COMMON_ERROR);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-photo-choice-button/syllabus-photo-choice-button.component.ts